export default __webpack_public_path__ + "c0310d2acdcbc2712d14367b174c20b4.png";